module.exports = __webpack_public_path__ + "img/bg.15d49138.png";